import React from 'react';
import { v4 as uuid } from 'uuid';
import PropTypes from 'prop-types';
import Icon, { iconsDictionary } from './Icon';
import { customIconsDictionary } from './Icons';
import { iconsList } from '../../constants/iconsList';
import { navbarIcons } from '../Navbar/Navbar';
import HeaderIconTooltip from '../HeaderIconTooltip/HeaderIconTooltip';

/* eslint-disable react/no-multi-comp */
const IconGallery = ({ iconSet }) => {
  const renderIcons = (icons, filePath, description) => (
    <div className="flex flex-col items-center my-8">
      <div className="flex items-center pb-8 gap-2">
        <h2 className="font-bold whitespace-nowrap text-lg text-black">{description}</h2>
        <div className="flex items-center">
          <HeaderIconTooltip
            divTextStart="Path to this file:"
            divTextEnd={filePath}
            place="bottom-end"
            iconName="icon_circle"
            paddingBottom="0"
            className="p-0 text-left"
            margins="mr-4 mb-0 my-auto"
            border="border-0"
            tooltipId={`tooltip-${description.replace(/ /g, '-')}`}
          />
        </div>
      </div>
      <div className="grid grid-cols-3 gap-8">
        {icons.map(({
          Component, label, value, path,
        }) => (
          <div key={uuid()} className="flex flex-col items-center space-y-2">
            <div className="flex items-center justify-center w-8 h-8">
              {Component ? (
                <Component className="w-full h-full text-vamos-green1" />
              ) : (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="w-full h-full">
                  <path d={path} />
                </svg>
              )}
            </div>
            <p className="mt-2 text-sm text-center">{label || value}</p>
          </div>
        ))}
      </div>
    </div>
  );

  switch (iconSet) {
    case 'iconsDictionary':
      return renderIcons(Object.entries(iconsDictionary).map(([key, icon]) => ({ Component: () => <Icon name={key} />, label: icon.alt })), 'app/javascript/src/componentsV2/Icons/Icon.js', 'Icon.js (icons from svg files)');
    case 'customIconsDictionary':
      return renderIcons(customIconsDictionary.map(({ Component, label }) => ({ Component, label })), 'app/javascript/src/componentsV2/Icons/Icons.js', 'Icons.js (icons from svg code)');
    case 'iconsList':
      return renderIcons(iconsList, 'app/javascript/src/constants/iconsList.js', 'iconsList.js (icons from @mdi/js)');
    case 'navbarIcons':
      return renderIcons(navbarIcons.map(({ Component, label }) => ({ Component, label })), 'app/javascript/src/componentsV2/Navbar/ Navbar.js', 'Navbar.js (icons from react-icons/md)');
    default:
      return null;
  }
};

IconGallery.propTypes = {
  iconSet: PropTypes.string.isRequired,
};

export default IconGallery;
